import { render } from "./XMenu.vue?vue&type=template&id=02ccb5fe"
import script from "./XMenu.vue?vue&type=script&lang=js"
export * from "./XMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dindin.mombaby.kroutony.me/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__